export default {
  'pages.setting.dept.title': '部门管理',
  'pages.setting.dept.subtitle': '组织和管理公司部门',
  'pages.setting.dept.searchPlaceholder': '按部门名称或编码搜索',
  // 表格列
  'pages.setting.dept.column.deptName': '部门',
  'pages.setting.dept.column.deptCode': '部门编码',
  'pages.setting.dept.column.email': '邮箱',
  'pages.setting.dept.column.phone': '手机',
  'pages.setting.dept.column.memberCount': '成员数',
  'pages.setting.dept.column.status': '状态',
  'pages.setting.dept.column.operation': '操作',
  // 状态
  'pages.setting.dept.status.enabled': '启用',
  'pages.setting.dept.status.disabled': '禁用',
  // 操作
  'pages.setting.dept.add': '新增部门',
  'pages.setting.dept.edit': '编辑',
  'pages.setting.dept.addChild': '新增',
  // 弹窗标题
  'pages.setting.dept.modal.addTitle': '新增部门',
  'pages.setting.dept.modal.editTitle': '编辑部门',
  // 表单
  'pages.setting.dept.form.deptName': '部门名称',
  'pages.setting.dept.form.deptNamePlaceholder': '请输入部门名称',
  'pages.setting.dept.form.deptNameRequired': '请输入部门名称',
  'pages.setting.dept.form.deptCode': '部门编码',
  'pages.setting.dept.form.deptCodePlaceholder': '请输入部门编码',
  'pages.setting.dept.form.deptCodeRequired': '请输入部门编码',
  'pages.setting.dept.form.deptCodePattern': '部门编码只能包含数字、英文和下划线',
  'pages.setting.dept.form.deptCodeExists': '部门编码已存在',
  'pages.setting.dept.form.leader': '部门负责人',
  'pages.setting.dept.form.leaderPlaceholder': '请输入部门负责人',
  'pages.setting.dept.form.leaderRequired': '请输入部门负责人',
  'pages.setting.dept.form.parentId': '上级部门',
  'pages.setting.dept.form.parentIdPlaceholder': '请选择上级部门',
  'pages.setting.dept.form.email': '邮箱',
  'pages.setting.dept.form.emailPlaceholder': '请输入邮箱地址',
  'pages.setting.dept.form.emailInvalid': '请输入正确的邮箱地址',
  'pages.setting.dept.form.phone': '联系电话',
  'pages.setting.dept.form.phonePlaceholder': '请输入联系电话',
  'pages.setting.dept.form.phoneInvalid': '请输入正确的菲律宾手机号',
  'pages.setting.dept.form.orderNum': '排序',
  'pages.setting.dept.form.orderNumPlaceholder': '请输入排序号',
  'pages.setting.dept.form.status': '状态',
  'pages.setting.dept.form.statusRequired': '请选择状态',
  'pages.setting.dept.form.remark': '部门描述',
  'pages.setting.dept.form.remarkPlaceholder': '请输入备注信息',
  // 提示消息
  'pages.setting.dept.message.deleteSuccess': '删除成功',
  'pages.setting.dept.message.deleteRejected': '该部门下仍有用户或子部门,无法删除',
  'pages.setting.dept.message.deleteFailed': '删除失败',
  'pages.setting.dept.message.addSuccess': '新增成功',
  'pages.setting.dept.message.editSuccess': '编辑成功',
};
